import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { settings } from '../../../app.settings';
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component';
import { DialogListNetworksComponent } from '../../../shared/components/dialog-list-networks/dialog-list-networks.component';

@Component({
  selector: 'app-store-table',
  templateUrl: './store-table.component.html',
  styleUrls: ['./store-table.component.sass']
})
export class StoreTableComponent implements OnInit {
  @Input() displayEmpty = true;
  @Input() stores = [];
  @Input() page = 1;
  @Input() total = 0;
  @Input() ordering: string;
  @Input() filters: any = {};
  @Input() perPage = settings.pagination.perPage;
  @Output() pageChange = new EventEmitter();
  @Output() filtersChange = new EventEmitter();
  @Output() importClicked = new EventEmitter();
  @Output() storeDelete = new EventEmitter();
  @Output() orderingChange = new EventEmitter();

  paginationSettings = {};

  constructor(
    public confirmDialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.paginationSettings = {
      itemsPerPage: this.perPage,
      currentPage: this.page,
      totalItems: this.total || (this.stores || []).length
    };
  }

  getOrderingClass(col: string) {
    return {
      'table-order': this.ordering === col || this.ordering === '-' + col,
      'reverse': this.ordering === '-' + col
    };
  }

  onOrderBy(col: string) {
    this.orderingChange.emit(col === this.ordering ? '-' + col : col);
  }

  onPageChange($event: any) {
    this.pageChange.emit($event);
  }

  onTermChange($event: any) {
    this.filters.term = $event;
    this.filtersChange.emit(this.filters);
  }

  onImportClicked($event) {
    this.importClicked.emit($event);
  }

  onOpenNetworks (store) {
    this.confirmDialog.open(DialogListNetworksComponent, {
      width: '400px',
      data: {
        store: store
      }
    });
  }

  onDeleteStore(store) {
    const dialog = this.confirmDialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        text: 'shared.dialog.confirm.text.delete.store'
      }
    });

    dialog.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.storeDelete.emit(store);
      }
    });
  }

  getLastNetwork(store) {
    if (store.networks.length) {
      return store.networks[0].name;
    }
  }

  getOtherNetworkCount(store) {
    const count = store.networks.length - 1;

    if (count > 0) {
      return '(+' + count + ')';
    }
  }
}
